import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Button, Modal, Form, Card } from "react-bootstrap";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as PoliciesStyles from "../styles/policies";

function Policies() {
    const dispatch = useDispatch();
    const [file, setFile] = useState(null);
    const [policies, setPolicies] = useState([]);

    const addPolicyModalDefaults = {
        open: false,
        text: "",
        textValid: false,
        textTouched: false,
        fileTouched: false
    };

    const [addPolicyModal, setAddPolicyModal] = useState(addPolicyModalDefaults);

    function handleCloseAddPolicyModal() {
        setAddPolicyModal(addPolicyModalDefaults);
    }

    const editModalDefaults = {
        open: false,
        editUUID: 0,
        name: "",
        nameValid: false,
        nameTouched: false,
        order: 0,
        fileName: ""
    };
    const [editModal, setEditModal] = useState(editModalDefaults);

    function handleCloseEditModal() {
        setEditModal(editModalDefaults);
    }

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "Yes",
        showAccept: false,
        cancelName: "No",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    const [modal, setModal] = useState({
        header: "",
        open: false,
        message: ""
    });

    function handleCloseModal() {
        setModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - Policies"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        handleLoad();
    }, []);

    function handleLoad() {
        Axios.post("/pods/3dPrintingShop/policies/getPolicies")
            .then((res) => {
                const data = res.data;
                setPolicies(data.policies);
            })
            .catch((err) => console.log(err));
    }

    function handleOpenAddPolicyModal() {
        setAddPolicyModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    function handleTextChange(event) {
        const { value } = event.target;

        let isValid = false;
        if (value.length > 0) {
            isValid = true;
        }

        setAddPolicyModal((prevState) => {
            return { ...prevState, text: value, textValid: true };
        });
    }

    function handleInputChange(event) {
        const { files } = event.target;
        setFile(files);
    }

    function handleTextOnTouched() {
        setAddPolicyModal((prevState) => {
            return { ...prevState, textTouched: true };
        });
    }

    function handleAdd() {
        let continu = true;

        if (!addPolicyModal.textValid) {
            setAddPolicyModal((prevState) => {
                return { ...prevState, textTouched: true };
            });
            continu = false;
        }

        if (file == null) {
            setAddPolicyModal((prevState) => {
                return { ...prevState, fileTouched: true };
            });
        }

        if (continu) {
            addFile();
        }
    }

    function addFile() {
        const checkData = {
            fileName: file[0].name,
            fileSize: file[0].size,
            fileType: file[0].type,
            name: addPolicyModal.text
        };

        const uploadFormData = new FormData();
        uploadFormData.append("pdf", file[0]);
        uploadFormData.append("name", addPolicyModal.text);

        const uploadConfig = {
            headers: {
                "content-type": "multipart/form-data"
            }
        };

        Axios.post("/pods/3dPrintingShop/policies/checkFile", checkData)
            .then((res) => {
                const firstData = res.data;
                if (firstData.failed == "Yes") {
                    if (firstData.failed == "Yes") {
                        setModal({
                            header: "Upload",
                            message: firstData.message,
                            open: true
                        });
                    }
                } else {
                    Axios.post("/pods/3dPrintingShop/policies/uploadFile", uploadFormData).then((res) => {
                        const secondData = res.data;

                        if (secondData.error == "null") {
                            setAddPolicyModal(addPolicyModalDefaults);
                            handleLoad();
                        }
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handlePolicyView(fileName) {
        window.open(`/content/3dPrintingShop/policies/${fileName}`, "_blank");
    }

    function handleOpenEdit(uuid) {
        const name = policies.find((policy) => policy.uuid == uuid).name;
        const fileName = policies.find((policy) => policy.uuid == uuid).fileName;
        const order = parseInt(policies.find((policy) => policy.uuid == uuid).order);

        let isValid = false;
        if (name.length > 0) {
            isValid = true;
        }

        setEditModal((prevState) => {
            return { ...prevState, editUUID: uuid, name: name, nameValid: isValid, fileName: fileName, order: order, open: true };
        });
    }

    function handleEditNameTextChange(event) {
        const { value } = event.target;

        let isValid = false;

        if (value.length > 0) {
            isValid = true;
        }

        setEditModal((prevState) => {
            return { ...prevState, name: value, nameValid: isValid };
        });
    }

    function handleNameOnTouched() {
        setEditModal((prevState) => {
            return { ...prevState, nameTouched: true };
        });
    }

    function handleEditNameUpdate() {
        const data = { uuid: editModal.editUUID, name: editModal.name };
        Axios.post("/pods/3dPrintingShop/policies/updateFileName", data)
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.error == "null") {
                    handleLoad();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenDeleteConfirmModal(uuid) {
        setModalYN({
            heading: "Delete Policy",
            message: "Are you sure you want to delete this policy?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: handleDeleteAccepptance.bind(this, uuid),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function handleDeleteAccepptance(uuid) {
        const data = { uuid: uuid };
        Axios.post("/pods/3dPrintingShop/policies/deletePolicy", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    handleLoad();
                    setModalYN((prevState) => {
                        return { ...prevState, open: false };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handlePolicyOrder(direction) {
        let newPosition = 0;

        if (direction == "down") {
            newPosition = editModal.order + 1;
        }
        if (direction == "up") {
            newPosition = editModal.order - 1;
        }
        const currentUUID = policies.find((pol) => pol.order == editModal.order).uuid;
        const newUUID = policies.find((pol) => pol.order == newPosition).uuid;

        const data = { currentPosition: editModal.order, currentUUID: currentUUID, newPosition: newPosition, newUUID: newUUID };
        Axios.post("/pods/3dPrintingShop/policies/changeOrder", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    handleLoad();
                    setEditModal((prevState) => {
                        return { ...prevState, order: newPosition };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    // function findPolicyOrderIndex()

    return (
        <div style={PoliciesStyles.body}>
            <Row>
                <Col style={PoliciesStyles.columnRight}>
                    <Button onClick={handleOpenAddPolicyModal}>Add Policy</Button>
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    {policies.map((policy, index) => {
                        return (
                            <div key={index}>
                                <Card style={PoliciesStyles.cardStyle}>
                                    <Card.Body>
                                        <Row>
                                            <Col>{policy.name}</Col>
                                            <Col style={PoliciesStyles.columnRight}>
                                                <Button variant="success" onClick={handlePolicyView.bind(this, policy.fileName)}>
                                                    <i className="fa-solid fa-eye"></i>
                                                </Button>
                                                <Button variant="warning" onClick={handleOpenEdit.bind(this, policy.uuid)}>
                                                    <i className="fa-solid fa-pen-to-square"></i>
                                                </Button>
                                                <Button variant="danger" onClick={handleOpenDeleteConfirmModal.bind(this, policy.uuid)}>
                                                    <i className="fa-solid fa-trash-can"></i>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <br />
                            </div>
                        );
                    })}
                </Col>
            </Row>
            <Modal show={addPolicyModal.open} onHide={handleCloseAddPolicyModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Name:</Form.Label>
                        <Form.Control
                            isInvalid={addPolicyModal.textTouched && !addPolicyModal.textValid ? true : false}
                            type="text"
                            maxLength={50}
                            value={addPolicyModal.text}
                            onChange={handleTextChange}
                            onBlur={handleTextOnTouched}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a name!</Form.Control.Feedback>
                    </Form.Group>
                    <div style={PoliciesStyles.counter}>{50 - addPolicyModal.text.length}</div>
                    <br />
                    <Form.Group>
                        <Form.Control
                            isInvalid={addPolicyModal.fileTouched && file == null ? true : false}
                            type="file"
                            name="pdf"
                            onChange={handleInputChange}
                        />
                        <Form.Control.Feedback type="invalid">Please select a file!</Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleAdd}>Add</Button>
                    <Button onClick={handleCloseAddPolicyModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={editModal.open} onHide={handleCloseEditModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Policy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Name:
                    <div style={PoliciesStyles.editNameSection}>
                        <div style={PoliciesStyles.editNameTextbox}>
                            <Form.Control
                                isInvalid={editModal.nameTouched && !editModal.nameValid ? true : false}
                                type="text"
                                value={editModal.name}
                                onChange={handleEditNameTextChange}
                                onBlur={handleNameOnTouched}
                            />
                            <Form.Control.Feedback type="invalid">Please enter a name!</Form.Control.Feedback>
                        </div>
                        <Button onClick={handleEditNameUpdate}>Update</Button>
                    </div>
                    <hr />
                    <div style={PoliciesStyles.orderSection}>
                        Order: {editModal.order}
                        {editModal.order > 1 && (
                            <Button onClick={handlePolicyOrder.bind(this, "up")}>
                                <i className="fa-solid fa-chevron-up"></i>
                            </Button>
                        )}
                        {editModal.order < policies.length && (
                            <Button onClick={handlePolicyOrder.bind(this, "down")}>
                                <i className="fa-solid fa-chevron-down"></i>
                            </Button>
                        )}
                    </div>
                    <hr />
                    <div style={PoliciesStyles.fileSection}>
                        File Name: {editModal.fileName} <br /> (You cannot change the file in edit mode)
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseEditModal}>Close</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
            <Modal show={modal.open} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Policies;
